import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { IconSearch, IconCross } from '@xingternal/icons';
import { ttt } from '@xingternal/malt-tracking';
import styles from './SearchInput.css';
class SearchInput extends Component {
    constructor() {
        super(...arguments);
        this.queryEl = null;
        this.state = {
            isTypingTracked: false,
        };
        this.handleChange = () => {
            const { triggerInput, isOpen, activate } = this.props;
            if (triggerInput) {
                triggerInput(this.queryEl ? this.queryEl.value : '');
                // track start of the typing (only for the first time per search field active)
                if (!this.state.isTypingTracked) {
                    ttt.event('PropTrackAction', {
                        PropTrackAction: 'search_search-field_typing_start',
                    });
                    this.setState({ isTypingTracked: true });
                }
            }
            if (!isOpen && this.queryEl && this.queryEl.value !== '') {
                activate();
                ttt.event('PropTrackAction', {
                    PropTrackAction: 'search_search-field_click',
                });
            }
        };
        this.listenForSubmit = (event) => {
            const { highlightedIndex, deactivate } = this.props;
            // if one item is highlighted do not submit the form
            // another handler takes care of redirecting to the selected item's url
            if (event.key === 'Enter' && highlightedIndex === null) {
                this.handleSearchSubmit({ trackingKey: 'all_results_fallback' });
            }
            if (event.key === 'Escape') {
                deactivate();
                this.setState({ isTypingTracked: false });
            }
        };
        this.handleFocus = () => {
            const { isOpen, activate, triggerInput, query = '' } = this.props;
            if (!isOpen) {
                activate();
                triggerInput(query);
                ttt.event('PropTrackAction', {
                    PropTrackAction: 'search_search-field_click',
                });
            }
        };
        this.handleBlur = () => {
            this.setState({ isTypingTracked: false });
        };
        this.handleSearchSubmit = ({ trackingKey }) => {
            const { searchLink, query, navigateTo } = this.props;
            navigateTo(searchLink({
                query,
                trackingKey,
            }));
        };
        this.handleClickClear = () => {
            const { triggerInput } = this.props;
            triggerInput('');
            this.setState({ isTypingTracked: false });
        };
    }
    componentDidMount() {
        this.props.isOverlayOpen &&
            this.props.innerRef &&
            this.props.innerRef.current &&
            this.props.innerRef.current.querySelector('input').focus();
    }
    render() {
        const { query = '', intl: { formatMessage }, innerRef, getInputProps, isOverlayOpen, } = this.props;
        return (React.createElement("div", { onClick: this.props.activate, className: cx({
                [styles.inputOnOverlay]: isOverlayOpen,
            }), ref: innerRef },
            React.createElement("button", { className: styles.button, onClick: () => this.handleSearchSubmit({ trackingKey: 'all_results_fallback' }), title: formatMessage({
                    id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON',
                }) },
                React.createElement(IconSearch, { width: 24, height: 24 })),
            React.createElement("input", { "data-qa": "incremental-search-input", ...getInputProps({
                    'aria-label': formatMessage({
                        id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER',
                    }),
                    className: styles.input,
                    type: 'search',
                    ref: (ref) => (this.queryEl = ref),
                    placeholder: formatMessage({
                        id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER',
                    }),
                    value: query,
                    onKeyDown: this.listenForSubmit,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                }) }),
            isOverlayOpen && Boolean(query.length) && (React.createElement("button", { className: styles.clearButton, onMouseDown: this.handleClickClear, title: formatMessage({
                    id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON',
                }) },
                React.createElement(IconCross, { width: 24, height: 24 })))));
    }
}
SearchInput.displayName = 'SearchInput';
SearchInput.defaultProps = {
    isOpen: false,
    navigateTo: (...args) => window.location.assign(...args),
};
SearchInput.propTypes = {
    intl: PropTypes.object.isRequired,
    navigateTo: PropTypes.func,
    triggerInput: PropTypes.func.isRequired,
    activate: PropTypes.func.isRequired,
    deactivate: PropTypes.func.isRequired,
    searchLink: PropTypes.func.isRequired,
    getInputProps: PropTypes.func.isRequired,
    isOverlayOpen: PropTypes.bool.isRequired,
    highlightedIndex: PropTypes.number,
    className: PropTypes.string,
    query: PropTypes.string,
    isOpen: PropTypes.bool,
    innerRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any }),
    ]),
};
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map